import { Droppable } from "@hello-pangea/dnd";

import { useConfigurationContext } from "../root/ConfigurationContext";
import type { Company, LabeledValue } from "../types";
import { CompanyCard } from "./CompanyCard";

const findStageLabel = (stages: LabeledValue[], stageValue: string) => {
  const stage = stages.find((s) => s.value === stageValue);
  return stage ? stage.label : stageValue;
};

export const CompanyColumn = ({
  stage,
  companies,
}: {
  stage: string;
  companies: Company[];
}) => {
  const { companyLifecycleStages } = useConfigurationContext();
  return (
    <div className="flex-1 pb-8 w-64 min-w-[250px]">
      <div className="flex flex-col items-center">
        <h3 className="text-base font-medium">
          {findStageLabel(companyLifecycleStages, stage)}
        </h3>
        <p className="text-sm text-muted-foreground">
          {companies.length} compan{companies.length !== 1 ? "ies" : "y"}
        </p>
      </div>
      <Droppable droppableId={stage}>
        {(droppableProvided, snapshot) => (
          <div
            ref={droppableProvided.innerRef}
            {...droppableProvided.droppableProps}
            className={`flex flex-col rounded-2xl mt-2 gap-2 min-h-[150px] ${
              snapshot.isDraggingOver ? "bg-muted/50" : ""
            }`}
          >
            {companies.map((company, index) => (
              <CompanyCard key={company.id} company={company} index={index} />
            ))}
            {droppableProvided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  );
};
